// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1ZKG6","signatureBlock":"Footer_signatureBlock__20v7i","signature":"Footer_signature__1bMUa"};